import { enumParser } from '#validation/common/parsers';
import { MemberRole, ServiceAccountMemberRole } from '../constants';
export const memberRoleParser = enumParser(MemberRole);
export const serviceAccountMemberRoleParser = enumParser(ServiceAccountMemberRole);
